var EventHelper = {};

(function() {
	EventHelper.subscribeFunction = function(handlers) {
		assert(handlers instanceof Array, 'handlers is not an Array');

		return function(handler) {
			assert(typeof handler === 'function', 'handler is not a function');

			handlers.push(handler);
		};
	};

	EventHelper.unsubscribeFunction = function(handlers) {
		assert(handlers instanceof Array, 'handlers is not an Array');

		return function(handler) {
			assert(typeof handler === 'function', 'handler is not a function');

			for (var i = handlers.length - 1; i >= 0; i--) {
				if (handlers[i] === handler) {
					handlers.splice(i, 1);
				}
			}
		};
	};

	EventHelper.invokeFunction = function(handlers) {
		assert(handlers instanceof Array, 'handlers is not an Array');

		return function(a1, a2, a3, a4, a5) {
			for (var i = 0; i < handlers.length; i++) {
				handlers[i](a1, a2, a3, a4, a5);
			}
		};
	};

	EventHelper.createEvent = function(obj, eventName) {
		var handlers = [];
		obj[eventName + 'Subscribe'] = EventHelper.subscribeFunction(handlers);
		obj[eventName + 'Unsubscribe'] = EventHelper.unsubscribeFunction(handlers);
		obj[eventName + 'Invoke'] = EventHelper.invokeFunction(handlers);
	};
})();
